/* EAR PLAN product pages — one small engine for a single piece and for an ear stack (several pieces, each with its own size).
 * Vanilla JS, no dependencies. Prices, availability and stock come from the real variants; nothing is computed beyond sums.
 * No discount, promotion or substitution logic: a sold-out piece is never replaced, the composition is simply blocked. */
(function () {
  'use strict';
  var mqMobile = window.matchMedia('(max-width: 899px)');
  var fmtCache = {};
  function money(cents, cur) {
    var whole = cents % 100 === 0, key = (cur || 'USD') + whole;
    var nf = fmtCache[key] || (fmtCache[key] = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || 'USD', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }));
    return nf.format(cents / 100);
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }

  document.querySelectorAll('[data-ep-buy]').forEach(init);

  function init(rootEl) {
    var dataEl = rootEl.querySelector('script[data-ep-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var comps = data.components || [], stack = data.mode === 'stack';
    // price model "stack": the Ear Stack product's own variant (Finish x Ears) is the price and the only cart line; default "sum" adds the pieces
    var modelA = stack && data.priceModel === 'stack';
    var cta = rootEl.querySelector('[data-ep-cta]'), msg = rootEl.querySelector('[data-msg]'), added = rootEl.querySelector('[data-added]');
    var priceEl = rootEl.querySelector('[data-price]'), totalLabel = rootEl.querySelector('[data-total-label]'), availEl = rootEl.querySelector('[data-avail]');
    var sticky = rootEl.querySelector('[data-ep-sticky]'), stickyCta = rootEl.querySelector('[data-sticky-cta]'), stickyPrice = rootEl.querySelector('[data-sticky-price]');
    var ears = 1, busy = false, ctaState = 'blocked';

    var scopes = comps.map(function (c, i) { return stack ? rootEl.querySelector('[data-comp="' + i + '"]') : rootEl; });
    // selection: one value (or null) per option; options with a single possible value are fixed
    var sel = comps.map(function (c) {
      return c.options.map(function (n, oi) {
        var vals = [];
        c.variants.forEach(function (v) { if (vals.indexOf(v.options[oi]) < 0) vals.push(v.options[oi]); });
        return vals.length === 1 ? vals[0] : null;
      });
    });

    function matches(ci, skip) {
      return comps[ci].variants.filter(function (v) {
        return v.options.every(function (o, oi) { return oi === skip || sel[ci][oi] == null || sel[ci][oi] === o; });
      });
    }
    function resolved(ci) {
      if (sel[ci].some(function (s) { return s == null; })) return null;
      return comps[ci].variants.filter(function (v) { return v.options.every(function (o, oi) { return o === sel[ci][oi]; }); })[0] || null;
    }
    function soldOutAll(ci) { return !comps[ci].variants.some(function (v) { return v.available; }); }
    function minPrice(ci) {
      var pool = comps[ci].variants.filter(function (v) { return v.available; });
      if (!pool.length) pool = comps[ci].variants;
      return Math.min.apply(null, pool.map(function (v) { return v.price; }));
    }
    function missingOptions(ci) {
      return comps[ci].options.filter(function (n, oi) { return sel[ci][oi] == null; });
    }

    function commonFinish() {
      var vals = comps.map(function (c, ci) { return finishIdx[ci] < 0 ? null : sel[ci][finishIdx[ci]]; }).filter(Boolean);
      return vals.length && vals.every(function (x) { return x === vals[0]; }) ? vals[0] : null;
    }
    function stackVariant(n) {
      if (!modelA) return null;
      var sp = data.stackProduct || {}, names = sp.options || [], ei = names.indexOf('Ears'), fi = names.indexOf('Finish'), want = (n || ears) === 2 ? /two|both|2/i : /one|1/i;
      var pool = (sp.variants || []).filter(function (v) { return ei < 0 || want.test(v.options[ei]); });
      if (!pool.length) return null;
      var f = commonFinish(), exact = f && fi >= 0 ? pool.filter(function (v) { return v.options[fi] === f; })[0] : null;
      return exact || pool.filter(function (v) { return v.available; })[0] || pool[0];
    }

    function evaluate() {
      var missing = [], out = [], capped = [], total = 0, from = 0, complete = true;
      comps.forEach(function (c, ci) {
        var v = resolved(ci);
        if (soldOutAll(ci)) out.push(c.title);
        if (!v) { complete = false; if (missingOptions(ci).length && !soldOutAll(ci)) missing.push(ci); from += minPrice(ci); return; }
        total += v.price; from += v.price;
        if (!v.available) out.push(c.title);
        else if (!modelA && v.max != null && v.max < (stack ? ears : 1)) capped.push({ title: c.title, max: v.max });
      });
      var mult = modelA ? 1 : (stack ? ears : 1), sv = modelA ? stackVariant() : null;
      if (sv) { total = sv.price; from = sv.price; }
      return { missing: missing, out: out, capped: capped, total: total * mult, from: from * mult, complete: complete, sv: sv, noStack: modelA && !sv };
    }

    function render() {
      // pills
      comps.forEach(function (c, ci) {
        var scope = scopes[ci]; if (!scope) return;
        scope.querySelectorAll('.ep-opt[data-ci="' + ci + '"]').forEach(function (g) {
          var oi = parseInt(g.dataset.opt, 10);
          g.querySelectorAll('.ep-pill').forEach(function (b) {
            var val = b.dataset.value, m = matches(ci, oi).filter(function (v) { return v.options[oi] === val; });
            var avail = m.some(function (v) { return v.available; });
            b.setAttribute('aria-pressed', sel[ci][oi] === val ? 'true' : 'false');
            b.setAttribute('aria-disabled', avail ? 'false' : 'true');
            b.classList.toggle('is-out', !avail);
            var so = b.querySelector('[data-soldout]'); if (so) so.hidden = avail;
          });
          var s = g.querySelector('[data-opt-sel]'); if (s) s.textContent = sel[ci][oi] != null && g.querySelectorAll('.ep-pill').length > 1 ? '· ' + sel[ci][oi] : '';
        });
        if (stack) {
          var v = resolved(ci), st = scope.querySelector('[data-status]'), rp = scope.querySelector('[data-row-price]'), pl = scope.querySelector('[data-pick-label]');
          if (st) { st.textContent = soldOutAll(ci) ? 'Currently sold out' : v ? (v.available ? 'Available' : 'Sold out') : ''; st.classList.toggle('is-out', soldOutAll(ci) || (v && !v.available)); }
          if (rp) { rp.hidden = modelA; rp.textContent = modelA ? '' : v ? money(v.price, data.currency) : 'From ' + money(minPrice(ci), data.currency); }
          if (pl) { var miss = missingOptions(ci); pl.textContent = miss.length ? 'Choose ' + miss.join(' / ').toLowerCase() : sel[ci].filter(function (x, i) { return c.variants.length > 1 && x != null; }).join(' · '); }
        }
      });

      var ev = evaluate(), reason = '', label, state;
      if (data.blocked) { state = 'blocked'; reason = data.blocked; label = 'Not available'; }
      else if (ev.noStack || (ev.sv && !ev.sv.available)) { state = 'blocked'; label = 'Not available'; reason = ev.noStack ? 'This ear is not available as a set yet.' : 'This ear is currently sold out.'; }
      else if (ev.out.length) {
        state = 'blocked'; label = stack ? 'Not available' : 'Sold out';
        reason = stack ? ev.out.join(', ') + (ev.out.length > 1 ? ' are' : ' is') + ' currently sold out, so this ear cannot be ordered as a set.' : '';
      } else if (ev.capped.length) {
        state = 'blocked'; label = 'Not available';
        reason = ev.capped.map(function (x) { return x.title + ': only ' + x.max + ' available'; }).join('; ') + '. Choose one ear or another size.';
      } else if (!ev.complete) { state = 'select'; label = stack ? 'Choose sizes' + (ev.missing.length ? ' (' + ev.missing.length + ' left)' : '') : 'Choose ' + missingOptions(0).join(' / ').toLowerCase(); }
      else { state = 'ready'; label = (stack ? 'Add this ear to cart' : 'Add to cart') + ' — ' + money(ev.total, data.currency); }
      ctaState = state;

      if (stack && totalLabel) totalLabel.textContent = modelA || (ev.complete && !ev.out.length) ? 'Total' : 'From';
      if (priceEl) priceEl.textContent = stack ? money(ev.complete && !ev.out.length ? ev.total : ev.from, data.currency) : (resolved(0) ? money(resolved(0).price, data.currency) : (comps[0].variants.some(function (v) { return v.price !== comps[0].variants[0].price; }) ? 'From ' : '') + money(minPrice(0), data.currency));
      if (availEl && !stack) { var v0 = resolved(0); availEl.textContent = v0 ? (v0.available ? 'Available' : 'Sold out') : ''; }
      [cta, stickyCta].forEach(function (b) { if (!b) return; b.setAttribute('aria-disabled', state === 'ready' && !busy ? 'false' : (state === 'select' ? 'false' : 'true')); b.dataset.state = state; b.textContent = busy ? 'Adding…' : label; });
      if (stickyPrice) stickyPrice.textContent = stack ? priceEl && priceEl.textContent : priceEl && priceEl.textContent;
      if (msg && !msg.dataset.keep) msg.textContent = reason;
      if (stickyCta) stickyCta.dataset.state = state;
      syncSavings(ev);
      syncAllFinish();
      syncGallery();
    }

    function setMsg(t) { if (msg) { msg.textContent = t; msg.dataset.keep = t ? '1' : ''; } }
    function clearMsg() { if (msg) { msg.dataset.keep = ''; } }

    // ---------- events ----------
    rootEl.querySelectorAll('.ep-opt').forEach(function (g) {
      var ci = parseInt(g.dataset.ci, 10), oi = parseInt(g.dataset.opt, 10);
      g.querySelectorAll('.ep-pill').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.getAttribute('aria-disabled') === 'true') return;
          sel[ci][oi] = sel[ci][oi] === b.dataset.value ? null : b.dataset.value;
          // drop other choices that became impossible
          comps[ci].options.forEach(function (n, j) { if (j !== oi && sel[ci][j] != null && !matches(ci, j).some(function (v) { return v.options[j] === sel[ci][j]; })) sel[ci][j] = null; });
          clearMsg(); if (added) added.hidden = true; render();
          var sheet = scopes[ci] && scopes[ci].querySelector('[data-sheet]');
          if (sheet && sheet.open && mqMobile.matches && !missingOptions(ci).length) setTimeout(function () { sheet.close(); }, 220);
        });
      });
    });
    rootEl.querySelectorAll('[data-ears]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { ears = parseInt(r.value, 10); clearMsg(); if (added) added.hidden = true; render(); } });
    });

    // ---------- one finish for the whole ear (stack only) ----------
    // Sets the Finish option of every piece that offers that value. Each piece can still be changed on its own row.
    var allFinish = null;
    var finishIdx = comps.map(function (c) { return c.options.indexOf('Finish'); });
    function finishValues() {
      var vals = [];
      comps.forEach(function (c, ci) { if (finishIdx[ci] < 0) return; c.variants.forEach(function (v) { var x = v.options[finishIdx[ci]]; if (vals.indexOf(x) < 0) vals.push(x); }); });
      return vals;
    }
    function applyFinish(val) {
      comps.forEach(function (c, ci) {
        var oi = finishIdx[ci]; if (oi < 0) return;
        if (!c.variants.some(function (v) { return v.options[oi] === val; })) return;
        sel[ci][oi] = val;
        c.options.forEach(function (n, j) { if (j !== oi && sel[ci][j] != null && !matches(ci, j).some(function (v) { return v.options[j] === sel[ci][j]; })) sel[ci][j] = null; });
      });
      clearMsg(); if (added) added.hidden = true; render();
    }
    function syncAllFinish() {
      if (!allFinish) return;
      allFinish.querySelectorAll('.ep-pill').forEach(function (b) {
        var val = b.dataset.value, on = comps.every(function (c, ci) { return finishIdx[ci] < 0 || sel[ci][finishIdx[ci]] === val || !c.variants.some(function (v) { return v.options[finishIdx[ci]] === val; }); });
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    (function buildAllFinish() {
      var vals = stack ? finishValues() : [], host = rootEl.querySelector('fieldset.ep-ears');
      if (vals.length < 2 || !host || !host.parentNode) return;
      allFinish = document.createElement('fieldset'); allFinish.className = 'ep-allfinish'; allFinish.setAttribute('data-all-finish', '');
      var lg = document.createElement('legend'); lg.className = 'ep-opt__l'; lg.textContent = 'Finish, all pieces'; allFinish.appendChild(lg);
      var pills = document.createElement('div'); pills.className = 'ep-pills';
      vals.forEach(function (val) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'ep-pill'; b.dataset.value = val; b.textContent = val; b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () { applyFinish(val); });
        pills.appendChild(b);
      });
      allFinish.appendChild(pills);
      var note = document.createElement('p'); note.className = 'ep-note'; note.textContent = 'Applies to every piece. You can still change one piece below.'; allFinish.appendChild(note);
      host.parentNode.insertBefore(allFinish, host);
    })();

    // ---------- option sheets (stack): bottom sheet on small screens, inline on larger ones ----------
    var sheets = [];
    rootEl.querySelectorAll('[data-sheet]').forEach(function (sheet) {
      var scope = sheet.closest('[data-comp]'), opener = scope.querySelector('[data-open-sheet]');
      sheets.push(sheet);
      if (opener) opener.addEventListener('click', function () { if (typeof sheet.showModal === 'function') sheet.showModal(); else sheet.setAttribute('open', ''); });
      sheet.querySelectorAll('[data-close-sheet]').forEach(function (b) { b.addEventListener('click', function () { sheet.close(); }); });
      sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
    });
    function layoutSheets() {
      sheets.forEach(function (sheet) {
        if (mqMobile.matches) { if (sheet.open && !sheet.matches(':modal')) sheet.close(); }
        else if (!sheet.open) { if (typeof sheet.show === 'function') sheet.show(); else sheet.setAttribute('open', ''); }
      });
    }
    layoutSheets();
    mqMobile.addEventListener('change', layoutSheets);

    // ---------- stack: highlight the pin of a piece while its row is hovered or focused (and the row of a hovered pin) ----------
    var compo = rootEl.querySelector('[data-ep-compo]');
    if (compo) {
      var setOn = function (n, on) {
        compo.querySelectorAll('.ep-stage__pin[data-pin="' + n + '"], .ep-stage__tag[data-pin="' + n + '"]').forEach(function (x) { x.classList.toggle('is-on', on); });
        var row = compo.querySelector('.ep-comp[data-pin="' + n + '"]'); if (row) row.classList.toggle('is-on', on);
      };
      compo.querySelectorAll('.ep-comp[data-pin]').forEach(function (row) {
        var n = row.getAttribute('data-pin');
        row.addEventListener('mouseenter', function () { setOn(n, true); });
        row.addEventListener('mouseleave', function () { setOn(n, false); });
        row.addEventListener('focusin', function () { setOn(n, true); });
        row.addEventListener('focusout', function () { setOn(n, false); });
      });
      compo.querySelectorAll('.ep-stage__pin[data-pin]').forEach(function (pin) {
        var n = pin.getAttribute('data-pin');
        pin.addEventListener('mouseenter', function () { setOn(n, true); });
        pin.addEventListener('mouseleave', function () { setOn(n, false); });
      });
    }

    // ---------- add to cart ----------
    function focusFirstMissing() {
      var ev = evaluate(); var ci = ev.missing[0] != null ? ev.missing[0] : 0; var scope = scopes[ci];
      var oi = sel[ci].findIndex(function (s) { return s == null; });
      var sheet = scope && scope.querySelector('[data-sheet]');
      if (sheet && mqMobile.matches) { sheet.showModal(); }
      var btn = scope && scope.querySelector('.ep-opt[data-opt="' + oi + '"] .ep-pill:not([aria-disabled="true"])');
      if (btn) { if (!(sheet && mqMobile.matches)) btn.scrollIntoView({ block: 'center', behavior: 'smooth' }); btn.focus({ preventScroll: true }); }
      return ev;
    }
    function onCta() {
      if (busy) return;
      if (ctaState === 'select') {
        var ev = focusFirstMissing();
        setMsg(stack ? 'Please choose a size for: ' + ev.missing.map(function (i) { return comps[i].title; }).join(', ') + '.' : 'Please choose ' + missingOptions(0).join(' / ').toLowerCase() + '.');
        return;
      }
      if (ctaState !== 'ready') return;
      busy = true; clearMsg(); render();
      var gid = uid(), q = stack ? ears : 1, items;
      if (modelA) {
        // one line: the Ear Stack variant; the chosen pieces and sizes travel as line properties (shown in the cart, passed to the order)
        var props = { '_stack': data.stack.handle, '_ears': String(ears), '_n': String(comps.length) };
        var svp = stackVariant(); if (svp && svp.compare > svp.price) props['_was'] = String(svp.compare);
        comps.forEach(function (c, ci) { props['Piece ' + (ci + 1)] = c.title + ' — ' + resolved(ci).options.join(' / '); });
        items = [{ id: stackVariant().id, quantity: 1, properties: props }];
      } else items = comps.map(function (c, ci) {
        var v = resolved(ci), it = { id: v.id, quantity: q };
        if (stack) it.properties = { 'Composition': data.stack.title + ' · ' + (ears === 2 ? 'Both ears' : 'One ear'), '_group': gid, '_stack': data.stack.handle, '_slot': String(ci + 1), '_n': String(comps.length), '_ears': String(ears) };
        return it;
      });
      fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw res.j || {};
          busy = false; render(); setMsg(''); if (added) added.hidden = false;
          refreshHeaderCount(); document.dispatchEvent(new CustomEvent('ep:cart-added'));
        })
        .catch(function (err) {
          var done = stack && !modelA ? cleanup(gid) : Promise.resolve();
          done.then(function () {
            busy = false; render();
            setMsg((err && err.description) ? err.description : 'We could not add this to your cart. Please try again.');
            refreshHeaderCount();
          });
        });
    }
    function cleanup(gid) { // a partial add must never leave an incomplete composition in the cart
      return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var keys = (cart.items || []).filter(function (it) { return it.properties && it.properties._group === gid; }).map(function (it) { return it.key; });
        return keys.reduce(function (p, key) { return p.then(function () { return fetch(root() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }); }); }, Promise.resolve());
      }).catch(function () {});
    }
    function refreshHeaderCount() {
      fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var link = document.querySelector('.ep-header__tools a[aria-label^="Cart"]'); if (!link) return;
        link.setAttribute('aria-label', 'Cart, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items'));
        var n = link.querySelector('.ep-cart__n');
        if (!n && cart.item_count > 0) { n = document.createElement('span'); n.className = 'ep-cart__n'; n.setAttribute('aria-hidden', 'true'); link.appendChild(n); }
        if (n) { if (cart.item_count > 0) n.textContent = cart.item_count; else n.remove(); }
      }).catch(function () {});
    }
    [cta, stickyCta].forEach(function (b) { if (b) b.addEventListener('click', onCta); });

    // ---------- sticky bar (small screens): shown once the main button is out of view ----------
    if (sticky && cta) {
      // Position-based (not IntersectionObserver): a jump past the button, for example when a size picker scrolls the page,
      // must still show the bar. Any scroll container is caught with a capturing listener.
      var queued = false;
      var syncSticky = function () {
        queued = false;
        var top = cta.getBoundingClientRect().top, bottom = cta.getBoundingClientRect().bottom;
        sticky.hidden = !(mqMobile.matches && bottom < 0 && top < 0);
      };
      var askSync = function () { if (!queued) { queued = true; window.requestAnimationFrame(syncSticky); } };
      document.addEventListener('scroll', askSync, { passive: true, capture: true });
      window.addEventListener('resize', askSync);
      mqMobile.addEventListener('change', askSync);
      syncSticky();
    }

    // savings are shown only for percentages set in the theme (= the same automatic discounts must exist in Shopify); nothing is shown otherwise
    var saveEl = rootEl.querySelector('[data-save]');
    function tierPct(n) { return window.EP_PCT ? window.EP_PCT(n) : 0; }
    var wasEl = rootEl.querySelector('[data-was]'), freeEl = rootEl.querySelector('[data-freeship]');
    // price model "stack": the Ear Stack variant price is the real price; its compare-at price is the sum of the pieces (set in Shopify); the saving is the difference
    function syncStackSaving(ev) {
      var o = window.EP_OFFERS || {}, sv = ev.sv, ok = sv && sv.compare > sv.price && ev.complete && !ev.out.length;
      if (wasEl) { wasEl.hidden = !ok; wasEl.textContent = ok ? money(sv.compare, data.currency) : ''; }
      if (saveEl) { saveEl.hidden = !ok; saveEl.textContent = ok ? 'Save ' + money(sv.compare - sv.price, data.currency) : ''; }
      if (freeEl) freeEl.hidden = !(o.stackFree && ev.complete && !ev.out.length);
      [1, 2].forEach(function (n) {
        var v = rootEl.querySelector('[data-ears-val="' + n + '"]'), b = rootEl.querySelector('[data-ears-save="' + n + '"]'), x = stackVariant(n);
        if (v) v.textContent = x ? money(x.price, data.currency) : '';
        if (b) { var sv2 = x && x.compare > x.price; b.hidden = !sv2; b.textContent = sv2 ? 'Save ' + money(x.compare - x.price, data.currency) : ''; }
      });
    }
    function syncSavings(ev) {
      if (!stack) return;
      if (modelA) return syncStackSaving(ev);
      var ready = ev.complete && !ev.out.length && !ev.capped.length && !ev.noStack && ears > 0;
      var one = ready ? ev.total / ears : 0;
      [1, 2].forEach(function (n) {
        var v = rootEl.querySelector('[data-ears-val="' + n + '"]'), b = rootEl.querySelector('[data-ears-save="' + n + '"]'), p = tierPct(comps.length * n);
        if (v) v.textContent = ready ? money(Math.round(one * n), data.currency) : '';
        if (b) { b.hidden = !p; b.textContent = p ? 'Save ' + p + '%' : ''; }
      });
      if (!saveEl) return;
      var pc = ready ? tierPct(comps.length * ears) : 0;
      saveEl.hidden = !pc;
      if (pc) { var save = Math.round(ev.total * pc / 100); saveEl.textContent = 'You save ' + money(save, data.currency) + ' (' + pc + '%) at checkout · ' + money(ev.total - save, data.currency); }
    }

    // ---------- gallery carousel ----------
    var gal = rootEl.querySelector('[data-ep-gal]');
    var galGo = function () {};
    if (gal) {
      var slides = [].slice.call(gal.children), cur = 0;
      var prev = rootEl.querySelector('[data-gal-prev]'), next = rootEl.querySelector('[data-gal-next]'), count = rootEl.querySelector('[data-gal-count]');
      var thumbs = [].slice.call(rootEl.querySelectorAll('[data-gal-thumb]'));
      var paint = function () {
        if (count) count.textContent = (cur + 1) + ' / ' + slides.length;
        if (prev) prev.disabled = cur === 0;
        if (next) next.disabled = cur === slides.length - 1;
        thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
      };
      galGo = function (i, smooth) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        gal.scrollTo({ left: i * gal.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      };
      if (slides.length > 1) {
        [prev, next, count].forEach(function (el) { if (el) el.hidden = false; });
        var tick = false;
        gal.addEventListener('scroll', function () {
          if (tick) return; tick = true;
          window.requestAnimationFrame(function () { tick = false; cur = Math.round(gal.scrollLeft / gal.clientWidth); paint(); });
        }, { passive: true });
        if (prev) prev.addEventListener('click', function () { galGo(cur - 1); });
        if (next) next.addEventListener('click', function () { galGo(cur + 1); });
        thumbs.forEach(function (t, i) { t.addEventListener('click', function () { galGo(i); }); });
        gal.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); galGo(cur + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); galGo(cur - 1); }
        });
        paint();
      }
    }
    // the selected single-piece variant shows its own linked image (only when one is linked)
    var shownMedia = null;
    function syncGallery() {
      if (stack || !gal) return;
      var rv = resolved(0), mid = rv && rv.media;
      if (!mid || mid === shownMedia) return;
      shownMedia = mid;
      var idx = [].slice.call(gal.children).findIndex(function (f) { return f.dataset.mid === String(mid); });
      if (idx > -1) galGo(idx);
    }

    render();
  }
})();
